



















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import FeedbackIcon from '@/components/icons/Feedback.vue';
import CloseIcon from '@/components/icons/Close.vue';
import ArrowBack from '@/components/icons/Arrow.vue';

import eventBus from '@/utils/eventBus';
import FeedbackService from '@/api/FeedbackService';
import Rating from '@/components/molecules/Rating/Rating.vue';
import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import {
  EFeedbackDeactivationType,
  TFeedbackDeactivationType
} from '@/models/feedback';
import segmentIo from '@/utils/segment.io';
import { capitalizeWords } from '@/utils';

@Component({
  components: {
    FilledButton,
    FeedbackIcon,
    Rating,
    SuccessFeedback,
    SelectionBox,
    CloseIcon,
    ArrowBack,
    Input
  }
})
export default class DeactivationReviewModal extends Vue {
  @Prop() type!: TFeedbackDeactivationType;
  @Prop() onSuccess!: Function;

  service = new FeedbackService();
  comment: string = '';
  success = false;
  loading = false;
  step = 1;
  options = [
    "I don't need it anymore",
    "It's missing features I need",
    'I just wanted to try it out',
    "I'm having a technical issue",
    'I found an alternative solution',
    'I added it by mistake',
    "It's too expensive for me",
    'I’m not ready to promote my program',
    'Other'
  ];

  EFeedbackDeactivationType = EFeedbackDeactivationType;

  form: any = {};

  get tPrefix() {
    return 'common.components.feedbackDisconnect';
  }

  get business() {
    if (!this.$store.getters['business/getBusinessInfo']) return {};
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get stepText() {
    return `step-${this.step}`;
  }

  get selectedOptions() {
    const selected: any = {};

    Object.keys(this.form).forEach(key => {
      if (this.form[key]) {
        selected[key] = true;
      }
    });

    return selected;
  }

  get provider() {
    if (this.$store.getters['merchant/getCurrentProvider'])
      return this.$store.getters['merchant/getCurrentProvider'].name;
    return '';
  }

  changeComment(comment: string) {
    this.comment = comment;
  }

  changeReasons() {
    segmentIo.track('Selected Deactivation Review Reason', {
      value: JSON.stringify(Object.keys(this.selectedOptions))
    });
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onBack() {
    this.step = 1;
  }

  async onSubmit() {
    try {
      if (this.step === 1) {
        segmentIo.track('Clicked Deactivation Review Next');
        this.step++;
        return;
      }
      segmentIo.track('Clicked Deactivation Review Submit');
      this.loading = true;

      await this.service.sendFeedbackDeactivation(this.type, {
        rating: 0,
        comment: this.comment,
        reasons: Object.keys(this.selectedOptions),
        provider: this.provider
      });
      this.onSuccess();
      this.success = true;
    } finally {
      this.loading = false;
    }
  }

  created() {
    segmentIo.modal(`Review ${capitalizeWords(this.type.replace('-', ' '))}`);
  }

  onSuccessClick() {
    this.onClose();
  }
}
